import { TabList } from '@mui/lab';
import { Tab } from '@mui/material';
import DisplayLanguageTab from './display-language-tab/display-language-tab.component';

type DisplayLanguageTabListProps = {
  value: any;
  droppableProvided: any;
  handleTabChange: (_e: any, selectedTab: any) => void;
};

const DisplayLanguageTabList = ({
  value,
  droppableProvided,
  handleTabChange,
}: DisplayLanguageTabListProps) => {
  return (
    <TabList
      onChange={handleTabChange}
      data-testid="DisplayLanguageTab.Section"
    >
      {value?.map((option, index) => {
        const child = (
          <Tab
            label={option.label}
            value={option.id}
            key={option.id}
            data-testid={`LanguageTabs.${option.id}`}
          />
        );

        return (
          <DisplayLanguageTab
            index={index}
            key={option.id}
            label={option.label}
            value={option.id}
            child={child}
          />
        );
      })}
      {droppableProvided?.placeholder}
    </TabList>
  );
};

export default DisplayLanguageTabList;
